import { jwtDecode } from "jwt-decode"

export function getToken() {
  return sessionStorage.getItem("token")
}

export function getUserInfo(tokenOverride) {
  const token = tokenOverride ?? getToken()
  if (!token) return null

  try {
    const decoded = jwtDecode(token)
    return decoded
  } catch (error) {
    console.error("Invalid token", error)
    return null
  }
}

export function getResetTokenInfo() {
  const resetToken = sessionStorage.getItem("passwordResetToken")
  if (!resetToken) return null

  try {
    const decoded = jwtDecode(resetToken)
    return decoded
  } catch (error) {
    console.error("Invalid password reset token", error)
    return null
  }
}

export function getPermissions(tokenOverride) {
  const info = getUserInfo(tokenOverride)
  return info?.permissions || []
}

export function getRoles(tokenOverride) {
  const info = getUserInfo(tokenOverride)
  return info?.role || []
}

export function isUserVerified(tokenOverride) {
  const info = getUserInfo(tokenOverride)
  return !!info?.is_verified
}
